import { BaseAction } from '../../../actions/utils/baseAction';

type Payload = {
  permalink: string;
  selected: boolean;
};

export type SelectPlexFilterItemAction = BaseAction<'selectPlexFilterItem', Payload>;

export const selectPlexFilterItem = (payload: Payload): SelectPlexFilterItemAction => ({
  type: 'selectPlexFilterItem',
  payload,
});
